import i18n from '@/plugins/i18n';

const _inputDefaultAttrs = {
  regular: true,
  color: 'primary',
  itemColor: 'primary',
  placeholder: String(i18n.t('admissionMap.filter.placeholders.select')),
  persistentPlaceholder: false,
  borderSelected: true,
}
export const AUTOCOMPLETE_ATTRS = {
  clearable: true,
  ..._inputDefaultAttrs,
}
export const TEXTFIELD_ATTRS = {
  ..._inputDefaultAttrs,
}
